import React from 'react';
import { createRoot } from 'react-dom/client';
import SODPDashboard from './components/SODPDashboard';

// Bootstrap function for standalone MFE
const mount = (element: HTMLElement) => {
  const root = createRoot(element);
  root.render(<SODPDashboard />);
  
  return () => {
    root.unmount();
  };
};

// If running in standalone mode, mount to #root
const devRoot = document.getElementById('root');
if (devRoot) {
  mount(devRoot);
}

export { mount };
export default SODPDashboard;
